export default {
    computed: {
        headers() {
            return [
                {
                    value: 'identifier',
                    text: this.$t('labels.identifier'),
                },
                {
                    value: 'name',
                    text: this.$t('labels.name'),
                    type: 'string',
                },
                {
                    value: 'cutoffTime',
                    text: this.$t('labels.cc_cutoff.time'),
                },
                {
                    value: 'deliveryTime',
                    text: this.$t('labels.delivery_at'),
                },
                {
                    value: 'budgetLimit',
                    text: this.$t('labels.budget'),
                },
            ]
        },
    },
}
